// src/components/Dashboard.js

import React from "react";
import Navbar from "./Navbar";

const Dashboard = () => {
  return (
    <div>
      <Navbar />
      <div className="container mt-5">
        <h2>Bem-vindo ao Sistema</h2>
        <p>Gerencie clientes e bancos de dados de forma fácil.</p>
      </div>
    </div>
  );
};

export default Dashboard;
